// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');
    this.swiperOptions = {
      direction: 'horizontal',
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });

    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false,
      Thumbs: {
        minSlideCount: 2,
      },
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}


/**
 * productDetail
 * @description Handles the logic for the tier pricing and product form
 */
class productDetail extends HTMLElement {

  /**
   * constructor
   */
  constructor() {
    super();

    // Elements
    this.element = this;
    this.options = {};

    // Get options from element data and combine with this.options
    if (this?.dataset?.productOptions) {
      const dataOptions = JSON.parse(this.dataset.productOptions);
      this.options = {
        ...this.options,
        ...dataOptions
      };
    }

    // Check if the form is on the page, if not stop
    this.form = this.querySelector('[data-product-template-form]');
    if(!this.form) {
      return;
    }

    // Get elements
    this.variantSelect = this.querySelector('[data-product-template-variant-select]');
    this.variantSelectRadios = this.variantSelect.querySelectorAll('[data-single-option-selector]');
    this.quantityInput = this.querySelector('[data-product-template-quantity-input]');
    this.priceWrapper = this.querySelector('[data-price-wrapper]');
    this.priceLabel = this.priceWrapper.querySelector('[data-product-price]');
    this.productMasterSelect = document.querySelector('[data-product-select]');

    // Available package sizes
    this.packageSizes = this.form.querySelector('[name="properties[_package_sizes]"]').value;
    this.packageSizesArray = this.packageSizes.split('|').map(Number).sort((a, b) => a - b);

    // Set initial package size
    this.currentPackageSize = this.packageSizesArray[0];

    // Catch click on quantity modifier on the product page +10 or -10 tier
    this.quantityModifier = this.querySelectorAll('[data-product-template-quantity-modifier]');
    this.quantityModifier.forEach((button) => {
      button.addEventListener('click', this.handleQuantityInputUpdate.bind(this));
    });

    // Update variants when it's clicked
    this.variantSelectRadios.forEach((radio) => {

      radio.addEventListener('click', () => {
        // Update the quantity input
        if (!this.options.disableTieredPricing) {
          this.quantityInput.value = radio.value;
        }
        // Update the variant select
        this.handleVariantSelectUpdate(radio.value, this.options.disableTieredPricing, radio.dataset.variantId);

        // When the option changes, update the master select variant id
        this.productMasterSelect.value = radio.dataset.variantId;

        document.dispatchEvent(new CustomEvent('variant-change', {
          bubbles: true,
        }));
      });

      radio.addEventListener('change', () => {
        // When the option changes, update the master select variant id
        this.productMasterSelect.value = radio.dataset.variantId;
      });
    });

  }

  /**
   * handleQuantityInputUpdate
   * @description Handle Product Quantity Input update.
   * @returns void
   * @access public
   */
  handleQuantityInputUpdate(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const wrapper = trigger.closest('[data-product-template-quantity-modifiers]');

    // Find quantity input
    const quantityInput = wrapper.querySelector('[data-product-template-quantity-input]');

    // Get quantities
    const currentValue = parseInt(quantityInput.value);
    const maxQuantity = parseInt(quantityInput.getAttribute('max'));

    // Update the minimum quantity to the most appropriate one according to the current quantity
    const minusButton = trigger.classList.contains('product__quantity-button--minus');
    const plusButton = trigger.classList.contains('product__quantity-button--plus');

    const getNewValue = (currentValue, operation) => {
      let newValue;

      // When value greater than this, increase the package size to this
      const maxValuePackageThreshold = 1000;
      const maxValuePackageSize = 100;

      // Find position in array and extrapolate prev and next sizes
      const i = this.packageSizesArray.indexOf(this.currentPackageSize);
      const prevSize = this.packageSizesArray[i - 1];
      const size = this.packageSizesArray[i];
      const nextSize = this.packageSizesArray[i + 1];

      if (operation === '+') {
        newValue = currentValue + (currentValue + this.currentPackageSize <= maxValuePackageThreshold ? this.currentPackageSize : maxValuePackageSize);

        if (nextSize && currentValue >= size) {
          if (currentValue < nextSize) {
            this.currentPackageSize = size;
            newValue = currentValue + this.currentPackageSize;

            if (newValue > nextSize) {
              this.currentPackageSize = nextSize;
              newValue = nextSize;
            }
          } else {
            this.currentPackageSize = nextSize;
            newValue = currentValue + this.currentPackageSize;
          }
        }
      }

      if (operation === '-') {
        newValue = currentValue - (currentValue - this.currentPackageSize <= maxValuePackageThreshold ? this.currentPackageSize : maxValuePackageSize);

        if (prevSize && newValue < size) {
            this.currentPackageSize = prevSize;

            const remainder = size % prevSize;
            newValue = size - remainder;
        }
      }

      this.currentPackageSize = this.currentPackageSize <= maxValuePackageThreshold ? this.currentPackageSize : maxValuePackageSize;

      return newValue;
    };

    const operation = minusButton ? '-' : '+';
    let newQuantity = getNewValue(currentValue, operation);

    // Check: if maximum quantity is reached
    if (newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
    }

    // if nothing changed or value is 0
    if (newQuantity === currentValue || newQuantity <= 0) return;

    // Update the quantity input
    this.quantityInput.value = newQuantity;

    // Update the variant select
    this.handleVariantSelectUpdate(newQuantity);
  }

  /**
   * handleVariantSelectUpdate
   * @param {Number} newQuantity
   * @access public
   * @returns void
   */
  handleVariantSelectUpdate(newQuantity, disableTieredPricing=false, variantId) {
    let newTierVariantId;
    let newActiveOption;

    // Check if tiered pricing is needed
    if (disableTieredPricing) {

      // Select the tier
      this.variantSelect.querySelector(`[data-single-option-selector]`).checked = false;
      newActiveOption = this.variantSelect.querySelector(`[data-single-option-selector][data-variant-id="${variantId}"]`);

    } else {

      // Check if new tier is needed
      if (typeof this.options.variants != 'undefined') {

        // Loop through all the variants and set the correct newTierVariantId
        for (let key in this.options.variants) {
          if (Object.prototype.hasOwnProperty.call(this.options.variants, key)) {
            let tier = parseInt(key);
            // Check if new quantity is above or equal to the new tier and set the current tier
            if (newQuantity >= tier) {
              newTierVariantId = this.options.variants[key];
            }
          }
        }

        // Select the tier
        this.variantSelect.querySelector(`[data-single-option-selector]`).checked = false;
        newActiveOption = this.variantSelect.querySelector(`[data-single-option-selector][data-variant-id="${newTierVariantId}"]`);

        // Set the current package size
        this.packageSizesArray.forEach((size) => {
          if (parseInt(newActiveOption.value) >= size) {
            this.currentPackageSize = size;
          }
        });

        // Dispatch event
        let event = new Event('change');
        newActiveOption.dispatchEvent(event);
      }
    }

    // Set the radio item active
    newActiveOption.checked = true;

    // Update the price
    const currentVariantPrice = this.variantSelect.querySelector('[data-single-option-selector]:checked').getAttribute('data-variant-price');
    let totalPrice = currentVariantPrice;
    if (!disableTieredPricing) {
      totalPrice = newQuantity * currentVariantPrice;
    }
    this.priceLabel.innerHTML = formatMoney(totalPrice);
  }
}

if(!customElements.get('product-detail')) {
  customElements.define('product-detail', productDetail);
}
